import { render, staticRenderFns } from "./TagsStep.vue?vue&type=template&id=28343d00&scoped=true&"
import script from "./TagsStep.vue?vue&type=script&lang=js&"
export * from "./TagsStep.vue?vue&type=script&lang=js&"
import style0 from "./TagsStep.vue?vue&type=style&index=0&id=28343d00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28343d00",
  null
  
)

export default component.exports